<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext pb-55">
      <div class="container pb-0">
        <div class="area_wrap">
          <div class="text_wrap caution list">
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item">
                    <div class="tw_title">
                      <h2>갑상선 수술 후</h2>
                      <h2>주의사항</h2>
                    </div>
                  </div>
                </template>

                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="tw_item btnItem other">
                      <a href="https://drive.google.com/file/d/1OPNe2Ia6MhYjNmF_SXGRuMXIO3hES4Wk/view?usp=sharing" target="_blank">
                        <button type="button">갑상선 수술 후 주의사항</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item">
                    <div class="tw_title">
                      <h2>갑상설관낭종절제술</h2>
                      <h2>주의사항</h2>
                    </div>
                  </div>
                </template>

                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="tw_item btnItem other">
                      <a href="https://drive.google.com/file/d/12ZPst3neu1D0XUB4I4u673xyly2eUUkt/view?usp=sharing" target="_blank">
                        <button type="button">갑상설관낭종절제술 주의사항</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>

            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item">
                    <div class="tw_title">
                      <h2>고주파열치료술</h2>
                      <h2>주의사항</h2>
                    </div>
                  </div>
                </template>

                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="tw_item btnItem other">
                      <a href="https://drive.google.com/file/d/1LboXNZC-8QbnYY1HxQ4Y89oLNQyiTt4T/view?usp=sharing" target="_blank">
                        <button type="button">고주파열치료술 주의사항</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>

            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item">
                    <div class="tw_title">
                      <h2>구강내수술</h2>
                      <h2>주의사항</h2>
                    </div>
                  </div>
                </template>

                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="tw_item btnItem other">
                      <a href="https://drive.google.com/file/d/1fekW0iuT3-R38QX1wh7StqB7zzTO0W_E/view?usp=sharing" target="_blank">
                        <button type="button">구강내수술 주의사항</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>

            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item">
                    <div class="tw_title">
                      <h2>기타절개수술</h2>
                      <h2>주의사항</h2>
                    </div>
                  </div>
                </template>

                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="tw_item btnItem other">
                      <a href="https://drive.google.com/file/d/1npAmh2WpdxQ8yQZHYOiYKaPELYyxyDWW/view?usp=sharing" target="_blank">
                        <button type="button">기타절개수술 주의사항</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>

            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item">
                    <div class="tw_title">
                      <h2>알코올경화술</h2>
                      <h2>주의사항</h2>
                    </div>
                  </div>
                </template>

                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="tw_item btnItem other">
                      <a href="https://drive.google.com/file/d/1wClyL4BbGyIWgrrrP8hNhFX8A5gcTrDc/view?usp=sharing" target="_blank">
                        <button type="button">알코올경화술 주의사항</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>

            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item">
                    <div class="tw_title">
                      <h2>이하선수술</h2>
                      <h2>주의사항</h2>
                    </div>
                  </div>
                </template>

                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="tw_item btnItem other">
                      <a href="https://drive.google.com/file/d/1GCBsJbFhCmELmRsjv1FFlP-BqDq_oy0_/view?usp=sharing" target="_blank">
                        <button type="button">이하선수술 주의사항</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>

            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item">
                    <div class="tw_title">
                      <h2>측경부림프절절제술(저지방식)</h2>
                      <h2>주의사항</h2>
                    </div>
                  </div>
                </template>

                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="tw_item btnItem other">
                      <a href="https://drive.google.com/file/d/1CwjlGo_A_3v7HyaPEP_ogUHohZEJBtsl/view?usp=sharing" target="_blank">
                        <button type="button">측경부림프절절제술(저지방식) 주의사항</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>

            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item">
                    <div class="tw_title">
                      <h2>편도절제술</h2>
                      <h2>주의사항</h2>
                    </div>
                  </div>
                </template>

                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="tw_item btnItem other">
                      <a href="https://drive.google.com/file/d/1FvaR9vf9TpcJovcOIdDpH1ZjcMGc2Y2s/view?usp=sharing" target="_blank">
                        <button type="button">편도절제술 주의사항</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>

            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item">
                    <div class="tw_title">
                      <h2>후두미세수술</h2>
                      <h2>주의사항</h2>
                    </div>
                  </div>
                </template>

                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="tw_item btnItem other">
                      <a href="https://drive.google.com/file/d/10vUYWhN_LcKwNaK0kBx-UG2CxVCHyLzy/view?usp=sharing" target="_blank">
                        <button type="button">후두미세수술 주의사항</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>

          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import BaseAccordion from '@/components/BaseAccordion'
export default {
  props: ['item'],
  data () {
    return {
      basic: {
        isShow: false,
        isOpen: false
      },
      transDate: {
        headerName: '수술 후 주의사항',
        prevUrl: '/'
      },
      setCount: false
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  methods: {
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    toggleList () {
      const areaArr = document.querySelectorAll('.tw_accordion')
      const menuTitle = document.querySelectorAll('.tw_title')
      const menuContent = document.querySelectorAll('.tw_detail')

      areaArr.forEach((el) => {
        const btn = el.querySelector('.tw_title')
        btn.addEventListener('click', () => {
          console.log(el)
          const targetContent = el.childNodes[1].classList
          const target = el.childNodes[0].childNodes[0]

          if (targetContent.contains('show')) {
            targetContent.remove('show')
            target.classList.remove('active')
          } else {
            menuTitle.forEach(function (el) {
              el.classList.remove('active')

              menuContent.forEach(function (el) {
                el.classList.remove('show')
              })
            })
            targetContent.add('show')
            target.classList.add('active')
          }
        })
      })
    },
    toggleEvent () {
      const areaArr = document.querySelectorAll('.tw_accordion')
      areaArr.forEach((area) => {
        const hasGroup = area.dataset.group !== undefined
        const btn = area.querySelector('.tw_title')
        const content = area.querySelector('.tw_detail')

        btn.addEventListener('click', () => {
          if (hasGroup === true) {
            const name = area.dataset.group
            const groupArr = document.querySelectorAll('.tw_accordion[data-group="' + name + '"]')
            const thisContent = area.querySelector('.tw_detail')

            groupArr.forEach((group) => {
              content.classList.remove('show')
              btn.classList.remove('active')
            })
            thisContent.classList.add('show')
            btn.classList.add('active')
          } else {
            if (content.classList.contains('show')) {
              areaArr.forEach((el) => {
                el.childNodes[1].classList.remove('show')
                el.childNodes[0].childNodes[0].classList.remove('active')
              })
            }
            content.classList.toggle('show')
            btn.classList.toggle('active')
          }
        })
      })
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    BaseAccordion
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>
<style lang="scss" scoped>
</style>
